import { toArray } from '@nrk/dh-utils'
import { HorizontalScroll } from '../../../../lib/scroll'
// import { debounce } from '../../../../lib/debounce'

export const SwipeContainerCustomElementName = 'dh-valg-2019-swipe'

export const SwipeContainer = __IS_SERVER__
  ? class {}
  : class extends HTMLElement {
      _activeIndex: number = 0

      _timeoutId: any

      _buttons: HTMLButtonElement[]

      _spacers: HTMLElement[]

      _indicators: HTMLElement

      connectedCallback() {
        if (this.buttons && this.buttons.length > 1) {
          const [left, right] = this.buttons
          left.addEventListener('click', this.scrollToLeft)
          right.addEventListener('click', this.scrollToRight)
        }

        // window.addEventListener('resize', this.updateWidthDebounced)

        const loop = () => {
          this.calculateActiveIndex()
          setTimeout(loop, 100)
        }
        this._timeoutId = setTimeout(loop, 100)
      }

      disconnectedCallback() {
        clearTimeout(this._timeoutId)
        if (this.buttons && this.buttons.length > 1) {
          const [left, right] = this.buttons
          left.removeEventListener('click', this.scrollToLeft)
          right.removeEventListener('click', this.scrollToRight)
        }

        // window.removeEventListener('resize', this.updateWidthDebounced)
        // this.updateWidthDebounced.cancel()
      }

      get scrollContainer() {
        return this.querySelector('[data-scroll-container="true"]') as HTMLElement
      }

      get buttons(): HTMLElement[] | undefined {
        if (!this._buttons) {
          this._buttons = toArray(this.querySelectorAll('button'))
        }
        return this._buttons
      }

      get spacers(): HTMLElement[] {
        if (!this._spacers) {
          const children = this.scrollContainer.children
          const left = children[0] as HTMLElement
          const right = children[children.length - 1] as HTMLElement
          this._spacers = [left, right]
        }
        return this._spacers
      }

      get indicators(): HTMLElement | undefined {
        if (!this._indicators) {
          this._indicators = this.querySelector('[data-scroll-indicator="true"]') as HTMLElement
        }
        return this._indicators
      }

      get activeIndex() {
        return this._activeIndex
      }

      set activeIndex(value) {
        if (value !== this._activeIndex) {
          this._activeIndex = value
          this.update()
          this.dispatchEvent(
            new CustomEvent('dh-valg-scroll-active-changed', {
              bubbles: true,
              detail: { nextIndex: value }
            })
          )
        }
      }

      get length() {
        if (this.scrollContainer) {
          return this.scrollContainer.children.length - 2
        } else {
          return 0
        }
      }

      get spacerWidth() {
        const children = this.scrollContainer.children
        if (children.length > 1) {
          const child = children[1] as HTMLElement
          return this.scrollContainer.offsetWidth / 2 - child.offsetWidth / 2
        } else {
          return 0
        }
      }

      scrollToLeft = () => {
        this.scrollToPos(this.getScrollLeft(this.activeIndex - 1))
        this.dispatchEvent(
          new CustomEvent('dh-valg-scroll-button-clicked', {
            bubbles: true,
            detail: { direction: 'left' }
          })
        )
      }

      scrollToRight = () => {
        this.scrollToPos(this.getScrollLeft(this.activeIndex + 1))
        this.dispatchEvent(
          new CustomEvent('dh-valg-scroll-button-clicked', {
            bubbles: true,
            detail: { direction: 'right' }
          })
        )
      }

      calculateActiveIndex = () => {
        const centerChild = this.findCenterChild()
        if (centerChild) {
          this.activeIndex = centerChild.idx - 1
        }
      }

      /*
      updateWidthDebounced = debounce(
        () => {
          this.spacers.forEach(spacer => {
            spacer.style.width = this.spacerWidth + 'px'
          })
        },
        { delay: 1000 }
      )
*/

      /*
      updateSpacerWidth = () => {
        this.spacers.forEach(spacer => {
          spacer.style.width = this.spacerWidth + 'px'
        })
      }
*/

      update() {
        // this.updateSpacerWidth()
        if (this.indicators) {
          toArray(this.indicators.children).forEach((indicator, idx) => {
            if (idx === this.activeIndex) {
              indicator.setAttribute('data-indicator-active', 'true')
            } else {
              indicator.removeAttribute('data-indicator-active')
            }
          })
        }

        if (this.scrollContainer) {
          toArray(this.scrollContainer.children).forEach((child, idx) => {
            const index = idx - 1
            if (index === this.activeIndex) {
              child.setAttribute('data-active', 'true')
            } else {
              child.removeAttribute('data-active')
            }
          })
        }

        if (this.buttons && this.buttons.length > 1) {
          const [left, right] = this.buttons
          if (this.activeIndex === 0) {
            left.setAttribute('data-button-hidden', 'true')
          } else {
            left.removeAttribute('data-button-hidden')
          }

          if (this.activeIndex === this.length - 1) {
            right.setAttribute('data-button-hidden', 'true')
          } else {
            right.removeAttribute('data-button-hidden')
          }
        }
      }

      findCenterChild() {
        const elm = this.scrollContainer

        if (elm && elm.children) {
          const containerWidth = elm.offsetWidth
          const scrollLeft = elm.scrollLeft
          return Array.from(elm.children)
            .map((child, idx) => ({ child, idx: idx }))
            .find(item => {
              const child = item.child as HTMLElement
              const leftOfCenter = child.offsetLeft < scrollLeft + containerWidth / 2
              const rightOfCenter =
                child.offsetLeft + child.offsetWidth > scrollLeft + containerWidth / 2
              return leftOfCenter && rightOfCenter
            })
        }
      }

      getScrollLeft(idx: number) {
        const elm = this.scrollContainer
        if (elm) {
          const child = elm.children[idx + 1] as HTMLElement | null
          if (child) {
            const elementCenter = child.offsetLeft + child.offsetWidth / 2
            const containerWidth = elm.offsetWidth
            return elementCenter - containerWidth / 2
          }
        }
      }

      scrollToPos = (left, time = 600) => {
        const elm = this.scrollContainer
        if (elm && !('scrollBehavior' in elm.style && elm.scrollTo)) {
          const verticalScroll = new HorizontalScroll(elm)
          requestAnimationFrame(() => verticalScroll.to(left, time))
        } else if (elm) {
          requestAnimationFrame(() => elm.scrollTo({ left, behavior: 'smooth' }))
        }
      }
    }
